import { Button } from '@sweep-io/sweep-design';
import { ButtonVariants } from '@sweep-io/sweep-design/dist/components/Button/types';
import { useCopyToClipboard } from './useCopyToClipboard';

interface CopyToClipboardButtonProps {
  textToCopy: string;
  variant?: ButtonVariants;
  size?: 'small' | 'medium';
}

export const CopyToClipboardButton = ({
  textToCopy,
  variant = 'flat-grey',
  size,
}: CopyToClipboardButtonProps) => {
  const { handleCopy, isCopied } = useCopyToClipboard();

  return (
    <Button
      variant={variant}
      size={size}
      startIconName={isCopied ? 'Check' : 'Copy'}
      onClick={async () => await handleCopy(textToCopy)}
      disabled={!textToCopy.trim()}
    >
      {isCopied ? 'Copied' : 'Copy to clipboard'}
    </Button>
  );
};
